import {
  IcErrorRhombusRegular,
  IcInformationCircleRegular,
  IcWarningTriangleRegular,
} from '@kep/kcds-icons';

import type { ComponentType, SVGProps } from 'react';
import type { SectionMessageVariant } from './constants';

const iconComponentMap = {
  error: IcErrorRhombusRegular,
  warning: IcWarningTriangleRegular,
  information: IcInformationCircleRegular,
} satisfies Record<SectionMessageVariant, ComponentType<SVGProps<SVGSVGElement>>>;

export interface SectionMessageIconProps extends SVGProps<SVGSVGElement> {
  variant: SectionMessageVariant;
}

const SectionMessageIcon = (props: SectionMessageIconProps) => {
  const { variant, ...others } = props;

  const IconComponent = iconComponentMap[variant];

  return <IconComponent {...others} />;
};

export default SectionMessageIcon;
